import { render, staticRenderFns } from "./create-portfolio-section-goal-configuration.vue?vue&type=template&id=f924ff84&scoped=true&lang=pug&"
import script from "./create-portfolio-section-goal-configuration.vue?vue&type=script&lang=js&"
export * from "./create-portfolio-section-goal-configuration.vue?vue&type=script&lang=js&"
import style0 from "./create-portfolio-section-goal-configuration.vue?vue&type=style&index=0&id=f924ff84&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f924ff84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
